import { render, staticRenderFns } from "./DatasetName.vue?vue&type=template&id=a5be59d8&scoped=true&"
import script from "./DatasetName.vue?vue&type=script&lang=js&"
export * from "./DatasetName.vue?vue&type=script&lang=js&"
import style0 from "./DatasetName.vue?vue&type=style&index=0&id=a5be59d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5be59d8",
  null
  
)

export default component.exports